import { Model } from 'modules/core/lib/mobx-rest'

interface ICallRequest {
  [key: string]: unknown
}

class CallRequest extends Model<ICallRequest> {
  static HubspotLead = {
    status: 'NEW',
    leadBirthplace: 'Inbound',
    leadOrigin: 'Inbound Contact Sales',
  }

  static urlRoot() {
    return '/internal/call_requests'
  }
}

export default CallRequest
